import { muiTheme } from '@tassat/payments-themes';

import { RecipientFieldProps } from './types';

export default (theme: typeof muiTheme, props: RecipientFieldProps) => ({
    container: (base) => ({
        ...base,
        width: props.components?.Input ? '100%' : 'auto',
        position: 'initial' as 'initial'
    }),
    valueContainer: (base) => ({
        ...base,
        display: props.components?.Input ? 'block' : 'none'
    }),
    indicatorsContainer: (base, state) => ({
        ...base,
        height: '44px',
        backgroundColor: state.selectProps.menuIsOpen ?
            (theme?.app?.clientTheme.colors.primaryColorLight || '#009BDF')
            : (theme?.app?.applicationColors.enumColors.white || '#FFFFFF')
    }),
    indicatorSeparator: (base) => ({
        ...base,
        display: 'none' as 'none'
    }),
    menu: (base) => ({
        ...base,
        minWidth: '15rem',
        left: 0
    }),
    singleValue: (base) => ({
        ...base,
        display: 'none'
    })
});